export const homepageRoutes = [
  {
    path: "",
    redirect: "/app/live-events",
    meta: {},
  },
  {
    path: "/",
    redirect: "/app/live-events",
    meta: {},
  },
  {
    path: "/dashboard",
    redirect: "/app/dashboard",
    meta: {},
  },
  {
    path: "/app",
    redirect: "/app/live-events",
    meta: {},
  },
];
